'use client';
import { jsx } from 'react/jsx-runtime';
import { CheckmarkIcon } from '@navikt/aksel-icons';
import cl from 'clsx/lite';

const SelectedIcon = ({ multiple, selected }) => {
    return (jsx("div", { className: cl(multiple && 'ds-combobox__option__icon-wrapper', selected && 'ds-combobox__option__icon-wrapper--selected'), children: selected && (jsx(CheckmarkIcon, { className: 'ds-combobox__option__icon-wrapper__icon', "aria-hidden": true })) }));
};
SelectedIcon.displayName = 'SelectedIcon';

export { SelectedIcon };
